import { UserLicenseDetailsSelectByIdOutputData } from './user-license-details-select-by-id-output-data.model';


export class UserLicenseDetailsSelectByIdOutput implements IUserLicenseDetailsSelectByIdOutput {
    status!: number;
    message!: string;
    data!: UserLicenseDetailsSelectByIdOutputData;

    constructor(data?: IUserLicenseDetailsSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? UserLicenseDetailsSelectByIdOutputData.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserLicenseDetailsSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UserLicenseDetailsSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IUserLicenseDetailsSelectByIdOutput {
    status: number;
    message: string;
    data: UserLicenseDetailsSelectByIdOutputData;
}

